const ContactIconSvg = ({
  width = 19,
  height = 14,
  viewBox = '0 0 19 14',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M1.72727 1.75H17.2727V12.25H1.72727V1.75ZM0.863636 0C0.634586 0 0.414916 0.0921874 0.252953 0.256282C0.09099 0.420376 0 0.642936 0 0.875V13.125C0 13.3571 0.09099 13.5796 0.252953 13.7437C0.414916 13.9078 0.634586 14 0.863636 14H18.1364C18.3654 14 18.5851 13.9078 18.747 13.7437C18.909 13.5796 19 13.3571 19 13.125V0.875C19 0.642936 18.909 0.420376 18.747 0.256282C18.5851 0.0921874 18.3654 0 18.1364 0H0.863636ZM10.3636 4.375H15.5455V6.125H10.3636V4.375ZM14.6818 7.875H10.3636V9.625H14.6818V7.875ZM4.31818 7.875H5.18182V10.5H6.90909V6.125H4.31818V7.875ZM6.90909 3.5H5.18182V5.25H6.90909V3.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ContactIconSvg;
